<template>
<div class="help">
  <div class="modal-background" @click.self="$emit('close')">
    <div class="modal-wrapper" :class="$mq">
      <div class="modal">
        <h1>
          {{ help.title }}
          <span class="close" @click.prevent="$emit('close')"></span>
        </h1>
        <h2 v-if="help.subtitle">
          {{ help.subtitle }}
        </h2>
        <p v-html="help.text" />
        <img v-if="help.image" :src="help.image" alt="?">
      </div>
      <button class="button main" @click.prevent="$emit('close')">{{ $t('back') }}</button>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    help: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
  .help {
    .modal-wrapper {
      text-align: center;

      h1 {
        width: auto;
      }
    }
  }

  .close {
    cursor: pointer;
    & > :first-child {
      margin-top: 2px;
    }
  }

  img {
    // display: block;
    height: 200px;
    margin: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Help.vue